import type { GraphQLError } from "graphql"

/**
 * GraphQLエラーのextensionsからcodeを取得する
 */
export const getExtensionsCode = (
	graphqlError: GraphQLError
): string | undefined => {
	const extensions = graphqlError.extensions

	if (extensions && typeof extensions.code === "string") {
		return extensions.code
	}

	return undefined
}

/**
 * GraphQLエラーのextensionsからmessagesを取得する
 */
export const getExtensionsMessages = (graphqlError: GraphQLError): string[] => {
	const extensions = graphqlError.extensions

	if (extensions && Array.isArray(extensions.messages)) {
		return extensions.messages.filter(
			(msg): msg is string => typeof msg === "string"
		)
	}

	return []
}
